import loadable from 'components/dynamic-import';

export const GiftChest = loadable(() => import('./ConnectedGiftChestForm'));
